import { throttle } from 'lodash';

class ButtonUtils {
    constructor($target) {
        this.$hiddenBtns = $('.js-hidden-btn');

        if (!this.$hiddenBtns.length) {
            return;
        }

        this.$window = $(window);
        this.addEventListeners($target);
    }

    addEventListeners($target) {
        this.$window.on('scroll', throttle(() => {
            this.onScrollPast($target);
        }, 100));
    }

    /**
     * Shows hidden button when $target leaves the viewport
     */
    onScrollPast($target) {
        const distance = $target.offset().top + $target.height();
        if (this.$window.scrollTop() >= distance) {
            if (this.$hiddenBtns && !this.$hiddenBtns.hasClass('show')) {
                this.$hiddenBtns.addClass('show');
            }
        } else if (this.$hiddenBtns && this.$hiddenBtns.hasClass('show')) {
            this.$hiddenBtns.removeClass('show');
        }
    }
}

export default ButtonUtils;
